import { LOCATION_CHANGE } from 'connected-react-router';
import { createMiddleware } from '../../shared/redux';
import { InternalRoutes } from './routes.constants';
import {
    isSignUpDataComplete,
    requestCheckSignUpData,
} from '../auth/check-sign-up-data/check-sign-up-data.state';

export const internalRoutesMiddleware = createMiddleware({
    [LOCATION_CHANGE]: (state, action) => {
        const { pathname } = action.payload.location;
        const isDestinationAnInternalRoute = Object.values(InternalRoutes).includes(pathname);
        const isSignUpDataIncomplete = !isSignUpDataComplete(state);

        if (isDestinationAnInternalRoute && isSignUpDataIncomplete) {
            return requestCheckSignUpData();
        }
        return [];
    },
});
